/* Celora — colour picker enhancer v2 (2026-08-31)
   CRO layer for the PDP variant pickers (colour swatches AND text pills):
   - per-value price caption under each swatch/pill — ONLY inside a fieldset
     whose values actually have different prices (per-fieldset check, so a
     Size fieldset with one price never gets noisy captions)
   - name + price native tooltip on every value
   - sold-out colours (swatch style) dimmed with a diagonal line
   Reads the variant JSON already printed by celora-sticky-atc.
   Annotation only — never touches the theme's picker logic. */
(function () {
  function getVariants() {
    var el = document.getElementById('CeloraVariantData');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function fmtNum(cents) {
    return Math.round(cents / 100).toLocaleString('en-US');
  }
  function annotate() {
    var variants = getVariants();
    if (!variants || !variants.length) return;
    var fieldsets = document.querySelectorAll('.product-form__input--swatch, .product-form__input--pill');
    if (!fieldsets.length) return;
    fieldsets.forEach(function (f) {
      var labels = f.querySelectorAll('label');
      if (!labels.length) return;
      var entries = [];
      labels.forEach(function (l) {
        var inp = document.getElementById(l.getAttribute('for'));
        if (!inp) return;
        var val = inp.value;
        var match = variants.filter(function (v) {
          return v.option1 === val || v.option2 === val || v.option3 === val;
        });
        if (!match.length) return;
        entries.push({
          l: l,
          val: val,
          min: Math.min.apply(null, match.map(function (v) { return v.price; })),
          avail: match.some(function (v) { return v.available !== false; })
        });
      });
      if (!entries.length) return;
      var mins = {};
      entries.forEach(function (e) { mins[e.min] = 1; });
      var multi = Object.keys(mins).length > 1;
      var isSwatch = f.classList.contains('product-form__input--swatch');
      f.classList.add('celora-sw-enhanced');
      f.classList.toggle('celora-sw-prices', multi);
      entries.forEach(function (e) {
        if (multi) e.l.setAttribute('data-celora-price', fmtNum(e.min));
        else e.l.removeAttribute('data-celora-price');
        e.l.title = e.val + ' — LE ' + fmtNum(e.min) + (e.avail ? '' : ' (sold out)');
        if (isSwatch) e.l.classList.toggle('celora-sw-soldout', !e.avail);
      });
    });
  }
  function boot() {
    annotate();
    /* the theme re-renders the picker on variant change — re-annotate.
       Observer watches childList only, so our own attribute writes never loop. */
    var host = document.querySelector('product-info, .product__info-container') || document.body;
    new MutationObserver(function () { annotate(); }).observe(host, { childList: true, subtree: true });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) {
        setTimeout(annotate, 120);
      }
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
